<template>
  <v-container fluid pa-0>
    <!-- Locations -->
    <v-layout row wrap>
      <v-flex xs12>
        
        <v-card>
<!--           <v-toolbar card color="primary">
            <v-toolbar-title class="headline font-weight-regular primary white--text" primary-title>
              Locations
            </v-toolbar-title>
          </v-toolbar> -->
          <v-card-text>
            
            <!-- Map with markers -->
            <v-sheet class="d-flex" color="grey lighten-3" height="500">
              <Mapbox name="map">
                <MapboxMarkers :locations="locationMarkers"></MapboxMarkers>
              </Mapbox>
            </v-sheet>

            <!-- Location listings -->
            <v-container grid-list-xs fluid>
              <v-layout row wrap>
                <template v-if="allLocations" v-for="location in allLocations">
                  <v-flex xs12 md6>
                    
                    <v-card>
                      <v-toolbar card color="primary">
                        <v-toolbar-title class="headline font-weight-regular white--text">
                          {{location.name ? location.name : location.title}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn color="pink" fab right fixed dark small :to="'/location/'+location.id">
                          <v-icon dark>edit</v-icon>
                        </v-btn>
                      </v-toolbar>
                      
                      <v-card-text>
                        <v-chip color="light-blue" text-color="white">
                          <v-avatar class="light-blue darken-3">
                            <v-icon>navigation</v-icon>
                          </v-avatar>
                          {{location.driveTime}} mins driving
                        </v-chip>
                        <v-chip color="light-blue" text-color="white">
                          <v-avatar class="light-blue darken-3">
                            <v-icon>traffic</v-icon>
                          </v-avatar>
                          {{location.trafficTime}} mins in traffic
                        </v-chip>
                        <v-chip v-if="location.uses_toll" color="light-blue" text-color="white">
                          <v-avatar class="light-blue darken-3">
                            <v-icon>toll</v-icon>
                          </v-avatar>
                           {{location.toll_cost}} toll
                        </v-chip>
                      </v-card-text>

                      <v-card-actions class="text-xs-center">
                        <v-layout row wrap>
                          <v-flex>
                            <v-btn dark color="black" :href="getAppleMapsLink(location)">Apple Maps</v-btn>
                          </v-flex>
                          <v-flex>
                             <v-btn dark color="indigo" :href="getGoogleMapsLink(location)">Google Maps</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>

                  </v-flex>
                </template>
              </v-layout>
            </v-container>

          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :loading="updating" :disabled="updating" color="info" @click.default="setLocations()">
              <v-icon>refresh</v-icon>
              <span slot="loader" class="custom-loader">
                <v-icon>refresh</v-icon>
              </span>
            </v-btn>
          </v-card-actions>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  // import Gmap from '@/components/Gmap'
  // import GMapMarker from '@/components/GMapMarker'
  import Mapbox from '../components/Mapbox';
  import MapboxMarkers from '../components/MapboxMarkers';

  import axios from 'axios';
  import { eventBus } from '../main';

  const fb = require('../firebaseConfig');
 
  // Required for side-effects
  
  var functions = fb.functions;
  var getDirectionsInfo = functions.httpsCallable('getDirectionsInfo');

  import { mapState } from 'vuex'

  export default {
    name: 'locationlistings', 
    data: () => ({
      geolocation: {
        location: null,
        position: null
      }, 
      mappedLocs: null, 
      lastUpdated: null, 
      updating: false
    }), 
    mounted(){
      this.geolocate( (geolocation) => {
        this.setLocations();
      });
    },
    computed: {
      ...mapState({
        allLocations: state => state.locations.locations
      }), 

      locationMarkers(){
        var markers = [] 

        this.allLocations.forEach((loc) => {
          let newPlace = {
            title: loc.title, 
            latlng: {
              lat: loc.latlng.lat, 
              lng: loc.latlng.lng
            }
          };

          markers.push(newPlace);

        })

        return markers
      }, 

      mappedLocations(){
        // Get all the matrices
        //    Callback from function and then return the data

        return this.allLocations.map( (loc) => {
          var updatedLocation = loc;

          updatedLocation.trafficTime = 5
          updatedLocation.driveTime = 4
          updatedLocation.uses_toll = 3
          updatedLocation.toll_cost = 2

          return updatedLocation;
        })
      }, 
      updateable(){
        if (this.lastUpdated == null ) {
          console.log('YES')
          return true;
        } else {
          let now = new Date();
          console.log(now.getTime())
          console.log(this.lastUpdated.getTime())
          var timeDifference = Math.abs(now.getTime() - this.lastUpdated.getTime())
          console.log(timeDifference);
          return (timeDifference > 90000) ? true : false;
        }
      }

    }, 
    methods: {
      getAppleMapsLink(location){
        return 'https://maps.apple.com/?daddr='+location.latlng.lat+','+location.latlng.lng;
      }, 
      getGoogleMapsLink(location){
        return 'https://www.google.com/maps/dir/?api=1&destination='+location.latlng.lat+','+location.latlng.lng
      }, 
      getDirectionsDetails(location, callback){
        // 'https://us-central1-zoomryde.cloudfunctions.net/getDirectionsInfo?origin=33.9724688,-117.5590318&destination=34.0247125,-117.5942713'

        fb.functions().httpsCallable('getDirectionsInfo')({origin: '33.9724688,-117.5590318', destination: '33.8176468,-117.9185408'})
          .then((result) => {
            callback(result);
          })
      }, 
      geolocate(callback = null){
        if (navigator.geolocation) {
          var options = {};

          navigator.geolocation.getCurrentPosition(position => {
              let geolocation = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude
              };

              this.geolocation.location = geolocation;
              this.geolocation.position = position;

              if (callback) callback(geolocation, position);
          }, err => {
            this.$emit('error', 'Cannot get Coordinates from navigator', err);
          }, options);
        }
      }, 
      /*
          @types = ['driving', 'driving-traffic']
      */
      getMatrix(origin, destinations, callback){
        var mapboxKey = 'pk.eyJ1IjoianVzdGlubXNoZXAiLCJhIjoiY2praGFucThsMHFrNDNxb3gzanExZmZrMiJ9.SJzutdGzBjRzG_pdFNvEGA';
        
        var destinationCoords = []

        destinations.forEach((e) => {
          destinationCoords.push(e.latlng.lng+','+e.latlng.lat)
        })

        let formattedOrigin = origin.lng+','+origin.lat;

        var drivingUrl = 'https://api.mapbox.com/directions-matrix/v1/mapbox/driving/'+formattedOrigin+';'+destinationCoords.join(';');
        var drivingTrafficUrl = 'https://api.mapbox.com/directions-matrix/v1/mapbox/driving-traffic/'+formattedOrigin+';'+destinationCoords.join(';');

        axios.all([
          axios.get(drivingUrl, {params: {sources: 0, destinations: "all",annotations: "duration,distance",access_token: mapboxKey}}),
          axios.get(drivingTrafficUrl, {params: {sources: 0, destinations: "all",annotations: "duration,distance",access_token: mapboxKey}}),
        ])
        .then( axios.spread( function(driving, traffic) {
          var returnValue = {}

          returnValue.distances = driving.data.distances[0].slice(1).map( (element) =>        { return (element == 0 ? 0 : Math.round(element/1609.34)) }); 
          returnValue.drivingduration = driving.data.durations[0].slice(1).map( (element) =>  { return (element == 0 ? 0 : Math.round(element/60)) });
          returnValue.trafficduration = traffic.data.durations[0].slice(1).map( (element) =>  { return (element == 0 ? 0 : Math.round(element/60)) });

          callback(returnValue);

        }))
        .catch((err) => {
          console.log(err);
          console.log(err.response.data);
          console.log(err.response.status);
          console.log(err.response.headers);
          console.log(err.request);
        })
      },
      // Maybe delete
      setLocations(){

        if(!this.updateable){
          eventBus.$emit('snackAlert', { color: 'warning', text: 'You need to wait at least a minute to update your locations.'});
          return;
        } else {
          this.mappedLocs = this.allLocations

          this.geolocate((location) => {
            this.updating = true;
            this.getMatrix(location, this.allLocations, (matrixValues) => {

              // Just need to go through and update each location
              this.mappedLocs.map( (location, index) => {

                  location.distance = matrixValues.distances[index];
                  location.driveTime = matrixValues.drivingduration[index];
                  location.trafficTime = (Math.max(matrixValues.trafficduration[index], matrixValues.drivingduration[index]) - Math.min(matrixValues.trafficduration[index], matrixValues.drivingduration[index]))

                  this.$store.dispatch('locations/updateLocation', location);

                  return location;
              })
              this.updating = false;
              this.lastUpdated = new Date();
            })
          })

          eventBus.$emit('snackAlert', { color: 'success', text: 'Locations updated succesfully!'});
        }

      }
    },
    watch: {
      allLocations(newLocs, oldLocs){

        //If we're not waiting for the data to be mounted ( != 'null') AND the length of newValue >= 0 (so there was a chanahge)
        if(typeof newLocs != 'null' && newLocs.length >= 0){
          
          this.mappedLocs = newLocs;

          this.setLocations();

        }
      }
    },
    components:{
      Mapbox, MapboxMarkers// Gmap, GMapMarker
    },
  }
</script>
<style>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>